import { ApiError } from '@lib/api/api-response';

export function isEntitlementDeniedError(error: unknown): error is ApiError {
  if (!(error instanceof ApiError) || error.status !== 402) {
    return false;
  }

  const body = error.response;
  return (
    typeof body === 'object' &&
    body !== null &&
    'code' in body &&
    (body as { code: unknown }).code === 'ENTITLEMENT_DENIED'
  );
}

export function getEntitlementDeniedReason(
  error: unknown
): 'tier_limit' | 'no_seats_available' | undefined {
  if (!isEntitlementDeniedError(error)) {
    return undefined;
  }

  const message = error.message.toLowerCase();
  if (message.includes('add seats')) {
    return 'no_seats_available';
  }

  return 'tier_limit';
}
